export default __webpack_public_path__ + "static/media/logo.a5b62bee.svg";